<template>
  <div class="overtime-rules">
    <div class="search">
      <el-select
        v-model="department"
        clearable
        class="gray"
        placeholder="请选择部门"
      >
        <el-option
          v-for="item in departmentList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>

      <el-button class="btn-blue" @click="search">搜索</el-button>
    </div>
    <div class="table">
      <el-table class="table-left" :data="tableData" style="width: 100%">
        <el-table-column prop="date" label="日期"></el-table-column>
        <el-table-column prop="times" label="编辑倍数">
          <template slot-scope="scope">
            <el-input
              class="white"
              @input="inputTimes(1, scope.$index, scope.row.times)"
              v-model="scope.row.times"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              class="btn-text"
              type="text"
              @click="updateTimes(scope.$index, 1)"
              >保存</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="tableData2" style="width: 100%">
        <el-table-column prop="date" label="日期"></el-table-column>
        <el-table-column prop="times" label="编辑倍数">
          <template slot-scope="scope">
            <el-input
              class="white"
              @input="inputTimes(2, scope.$index, scope.row.times)"
              v-model="scope.row.times"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              class="btn-text"
              type="text"
              @click="updateTimes(scope.$index, 2)"
              >保存</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getDecimal, formatTimeToDate, modifyNetTitle } from "common/js/util";
import Employee from "models/employee";
const employee = new Employee();
export default {
  data() {
    return {
      department: "",
      date: "",
      departmentList: [],
      tableData: [],
      tableData2: []
    };
  },
  created() {
    modifyNetTitle('加班规则')
    this.getCompanyList();
  },
  methods: {
    //获取部门数据
    getCompanyList() {
      employee.getDeptList().then(res => {
        let departmentList = [];
        if (res.success) {
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            departmentList.push(obj);
          });
          this.departmentList = departmentList;
          // this.department = departmentList[0].id;
          // this.getTableDate();
        }
      });
    },
    getTableDate() {
      let department = this.department;
      employee.getOvertimeList(department).then(res => {
        if (res.success) {
          let arr1 = [];
          let arr2 = [];
          res.result.map((value, index) => {
            let obj = {};
            obj.date = formatTimeToDate(value.date);
            obj.times = value.times;
            if ((index + 1) % 2 === 0) {
              arr2.push(obj);
            } else {
              arr1.push(obj);
            }
          });
          this.tableData = arr1;
          this.tableData2 = arr2;
        }
      });
    },
    search() {
      this.getTableDate();
    },
    //修改倍数
    updateTimes(index, type) {
      let deptId = this.department;
      let date = "";
      let times = "";
      if (type === 1) {
        date = this.tableData[index].date;
        times = this.tableData[index].times;
      } else {
        date = this.tableData2[index].date;
        times = this.tableData2[index].times;
      }
      let data = {
        deptId,
        date,
        times
      };
      employee.postUpdateOvertime(data).then(res => {
        if (res.success) {
          this.$message.success("修改成功");
          this.getTableDate();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //限制倍数输入
    inputTimes(type, index, num) {
      if (type === 1) {
        let times = getDecimal(num);
        this.tableData[index].times = times;
      } else {
        let times = getDecimal(num);
        this.tableData2[index].times = times;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.overtime-rules {
  flex: 1;
  .search {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;

    .btn-blue {
      margin-left: 16px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    .table-left {
      margin-right: 16px;
    }
  }
}
</style>
<style lang="scss">
.overtime-rules {
  .table {
    .el-table {
      .el-input {
        width: 110px;
        .el-input__inner {
          height: 24px;
          width: 110px;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>
